module.exports = __webpack_public_path__ + "static/img/mypage-menu-icon02_hover.1ca3dd6b.svg";